import styled from 'styled-components';
import { theme } from '../../styles/theme';
export const Wrapper = styled.div `
  background: linear-gradient(90deg, #d9cfff 0%, #5f5683 100%);
  border-radius: ${theme.spacing.xxs};
  display: flex;
  height: 8px;
  overflow: hidden;
  margin-top: ${theme.spacing.xs};
`;
export const Filled = styled.div `
  background: transparent;
  height: 8px;
  width: ${({ $segments }) => `calc(100% / ${$segments})`};

  & + & {
    border-left: 3px solid ${theme.colors.backgroundLightest};
  }
`;
export const Empty = styled(Filled) `
  background: ${theme.colors.backgroundLight};
`;
